const normalizeRoleName = (roleName = '') =>
  String(roleName)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();

const PERMISSIONS = {
  SUPER_ADMIN: 1,
  VIEW_MANAGE_LOCATIONS: 400,
  VIEW_MOVEMENTS_STOCK: 200,
  VIEW_SALES: 501,
  CREATE_PURCHASE: 1001,
  VIEW_SETTINGS: 802,
  MANAGE_STAFF_ROLES: 424,
  VIEW_TRANSACTIONS: 1002,
  VIEW_ALL_TRANSACTIONS: 1003,
  VIEW_SEND_INVOICES: 1201,
  VIEW_RECEIVED_INVOICES: 1202,
  VIEW_SUMMARY_INVOICES: 1203,
};

const normalizePermissions = (permissions = []) =>
  new Set(
    (Array.isArray(permissions) ? permissions : [])
      .map((permission) => Number(permission))
      .filter((permission) => !Number.isNaN(permission))
  );

export const isSuperadminRole = (roleName = '') => {
  const normalizedRole = normalizeRoleName(roleName);
  return normalizedRole === 'superadmin' || normalizedRole.includes('super admin');
};

export const isAccountingRole = (roleName = '') => {
  const normalizedRole = normalizeRoleName(roleName);
  return (
    normalizedRole === 'contador' ||
    normalizedRole.includes('contador') ||
    normalizedRole.includes('accountant') ||
    normalizedRole.includes('accounting')
  );
};

export const isAccountingOnlyPermissions = (permissions = []) => {
  const permissionSet = normalizePermissions(permissions);
  const hasAccountingPermissions =
    (
      permissionSet.has(PERMISSIONS.VIEW_SEND_INVOICES) ||
      permissionSet.has(PERMISSIONS.VIEW_RECEIVED_INVOICES) ||
      permissionSet.has(PERMISSIONS.VIEW_SUMMARY_INVOICES)
    ) &&
    permissionSet.has(PERMISSIONS.VIEW_ALL_TRANSACTIONS);

  const hasOperationalPermissions = [
    PERMISSIONS.VIEW_MANAGE_LOCATIONS,
    PERMISSIONS.VIEW_MOVEMENTS_STOCK,
    PERMISSIONS.VIEW_SALES,
    PERMISSIONS.CREATE_PURCHASE,
    PERMISSIONS.VIEW_SETTINGS,
    PERMISSIONS.MANAGE_STAFF_ROLES,
  ].some((permission) => permissionSet.has(permission));

  return hasAccountingPermissions && !hasOperationalPermissions;
};

export const isSuperadminPermissions = (permissions = []) => {
  return normalizePermissions(permissions).has(PERMISSIONS.SUPER_ADMIN);
};

export const canAccessAccounting = ({ roleName, permissions = [] } = {}) => {
  return (
    isSuperadminRole(roleName) ||
    isAccountingRole(roleName) ||
    isSuperadminPermissions(permissions) ||
    isAccountingOnlyPermissions(permissions)
  );
};
